
import { BCMSDefaultModel, BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import SettingsFastBalancesPage, { getDefaultPageData } from "components/pages/SettingsFastBalancesPage";
import Classes from "model";
import "./styles.css";

export default function CaptureFastBalancesNameEntered(props) {
    const globalController = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, globalController);
    const mobileDevice = BCMSDefaultModel.mobileDevice();
    mobileDevice.name = "George's Phone";
    mobileDevice.isEnrolled = false;

    const data = BCMSStateManagerCRUD.init(getDefaultPageData())
        .update([ "mobileDevice" ], mobileDevice)
        .submit();

    return <div class="name-entered-006"><SettingsFastBalancesPage data={ data } /></div>;
}